import TableHeaderWithSort from '../components/TableHeaderWithSort';
import { PROFITABILITY_SORT_OPTIONS } from '../constants/sortingOptions';

export const getProfitabilityTableHeaders = (sortFunction) =>
	Object.freeze([
		<TableHeaderWithSort
			displayName='Market'
			sortFunction={() => sortFunction(PROFITABILITY_SORT_OPTIONS.MARKET)}
		/>,
		'Consultant',
		'Bonus',
		'Base',
		<TableHeaderWithSort
			displayName='Profitability'
			sortFunction={() =>
				sortFunction(PROFITABILITY_SORT_OPTIONS.PROFITABILITY)
			}
		/>,
	]);
